// Redirects intentionally reject backslashes and ASCII control characters.
// eslint-disable-next-line no-control-regex
const UNSAFE_APP_PATH_CHARACTERS = /[\\\u0000-\u001f\u007f]/;

export function safeAppPath(value: string | null): string | null {
  if (!value?.startsWith("/") || value.trim() !== value || value.startsWith("//") || UNSAFE_APP_PATH_CHARACTERS.test(value)) return null;
  const pathname = value.split(/[?#]/, 1)[0];
  try {
    const decodedPath = decodeURIComponent(pathname);
    if (/%(?:2f|5c)/i.test(pathname)
      || UNSAFE_APP_PATH_CHARACTERS.test(decodedPath)
      || decodedPath.split("/").some((segment) => segment === "." || segment === "..")) return null;
    const base = "https://vendistri.invalid";
    return new URL(value, base).origin === base ? value : null;
  } catch {
    return null;
  }
}

export function authContinuation(search: string): string | null {
  const params = new URLSearchParams(search);
  return safeAppPath(params.get("redirect") || params.get("next"));
}

export function signupPath(continuation: string | null): string {
  const path = safeAppPath(continuation);
  return `/signup.html${path ? `?next=${encodeURIComponent(path)}` : ""}`;
}
